//  eslint-disable
import { BehaviorSubject } from "rxjs";
import GlobalStore from "@/store/modules/global";
import { UserGessan } from "@/models/gessan/userGessan";
import { router } from "@/router";
import { Auth } from "@/models/auth";
import JwtDecode from "jwt-decode";
import { BASE_PATH_APP } from "@/commons/config";
import { AuthApi } from "@/api/gessan/auth.api";
import { SaneamentoApi } from "@/api/gessan/saneamento.api";
import { Municipio } from "@/models/gessan/municipio";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { normalizeAlphanumericCNPJ } from "@/helpers/cnpj-alphanumeric.validator";

export interface UserJwtDecode {
  sub: number;
  nome: string;
  razaoSocial: string;
  nomeFantasia: string;
  cnpj: string;
  email: string;
  nomeResponsavel: string;
  cpfResponsavel: string;
  roles: Array<string>;
  isGrupo?: boolean;
}

const AUTH = `${BASE_PATH_APP}-gessan-auth`;
const api = new AuthApi();
const apiSaneamento = new SaneamentoApi();

const currentUser = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};

  if (!token) return null;

  const {
    sub,
    nome,
    razaoSocial,
    nomeFantasia,
    cnpj,
    email,
    nomeResponsavel,
    cpfResponsavel,
    roles,
    isGrupo,
  } = JwtDecode<UserJwtDecode>(token);

  return new UserGessan(
    sub,
    nome,
    razaoSocial,
    nomeFantasia,
    cnpj,
    email,
    nomeResponsavel,
    cpfResponsavel,
    roles,
    isGrupo
  );
};

const userSubject = new BehaviorSubject(currentUser());

userSubject.subscribe((user: UserGessan | null) => {
  if (GlobalStore) {
    GlobalStore.setUserGessan(user);
  }
});

const globalStore = (type: string, mensage: string) => {
  GlobalStore.setSnackBar({
    show: true,
    message: mensage,
    type,
    timeout: 4000,
  });
};

const getMunicipioLogado = (cnpj: string): AxiosObservable<Municipio> => {
  return apiSaneamento.getMunicipioLogado(normalizeAlphanumericCNPJ(cnpj));
};

const login = (cnpj: string, password: string) => {
  const normalizedCnpj = normalizeAlphanumericCNPJ(cnpj);

  return api.signin(normalizedCnpj, password).subscribe({
    next: response => {
      setSession(response);
      globalStore("success", "Login realizado com sucesso!");

      loginCentral(normalizedCnpj).subscribe({
        next: () => {},
        error: () => {},
      });
    },
    error: error => {
      const message = error?.response?.data?.message || "Erro ao realizar Login";
      globalStore("error", message);
    },
  });
};

const loginCentral = (cnpj: string) => {
  return api.siginCentral(cnpj);
};

const normalizeAuthResult = (authResult: any): Auth => authResult?.result || authResult;

const setSession = (authResult: any) => {
  buildAuth(normalizeAuthResult(authResult));
  userSubject.next(currentUser());
  router.push({ name: "saneamento-home" });
  return userSubject.value;
};

const buildAuth = ({ token, functionalities }: Auth) => {
  localStorage.setItem(AUTH, JSON.stringify({ token, functionalities }));
};

const removeAuth = () => {
  localStorage.removeItem(AUTH);
  userSubject.next(null);
};

const logout = (): void => {
  removeAuth();
  router.push("/saneamento/login");
};

const currentToken = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};
  return token;
};

export default {
  login,
  loginCentral,
  getMunicipioLogado,
  removeAuth,
  logout,
  globalStore,
  userSubject,
  get currentUserValue() {
    return userSubject.value;
  },
  get token() {
    return currentToken();
  },
};
